import {apolloClient} from '@/setup/apollo-setup';
import {error} from '@/utils/notification';
import {
  CREATE_BUNNY_UPLOAD,
  REFRESH_BUNNY_STATUS,
  DELETE_BUNNY_VIDEO,
  CANCEL_BUNNY_UPLOAD,
  BUNNY_DOWNLOAD_URL,
} from '@/queries/modules/vdoSet/bunnyUpload';

export async function createBunnyUpload(context, payload) {
  context.commit('setProcessing', true);
  try {
    const {data, errors} = await apolloClient.mutate({
      mutation: CREATE_BUNNY_UPLOAD,
      variables: {vdoSetTopicId: payload.vdoSetTopicId, title: payload.title},
    });

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    }
    context.commit('setTicket', data.createBunnyUpload);
    context.commit('setSuccess', null);
    return data.createBunnyUpload;
  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function refreshBunnyStatus(context, vdoSetTopicId) {
  context.commit('setProcessing', true);
  try {
    const {data, errors} = await apolloClient.mutate({
      mutation: REFRESH_BUNNY_STATUS,
      variables: {vdoSetTopicId},
    });

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    }
    context.commit('setTopic', data.refreshBunnyStatus);
    context.commit('setSuccess', null);
    return data.refreshBunnyStatus;
  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteBunnyVideo(context, vdoSetTopicId) {
  context.commit('setProcessing', true);
  try {
    const {data, errors} = await apolloClient.mutate({
      mutation: DELETE_BUNNY_VIDEO,
      variables: {vdoSetTopicId},
    });

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else if (data && data.deleteBunnyVideo) {
      context.commit('setTopic', data.deleteBunnyVideo);
      context.commit('setSuccess', null);
      return data.deleteBunnyVideo;
    } else {
      // Same refuse signal as deleteVdoSetTopic/deleteOnlyVideo in
      // vdo-set-topic/actions: a null data field (no GraphQL errors) means
      // the backend's current-period studentTopicLearn guard refused the
      // delete (Finding 1). Neither success nor error is committed here --
      // removeBunnyVideo reads the null return and shows the
      // "can-not-delete" warning itself, same as the Wowza path.
      context.commit('setProcessing', false);
      return null;
    }
  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function cancelBunnyUpload(context, vdoSetTopicId) {
  context.commit('setProcessing', true);
  try {
    const {data, errors} = await apolloClient.mutate({
      mutation: CANCEL_BUNNY_UPLOAD,
      variables: {vdoSetTopicId},
    });

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    }
    context.commit('setTopic', data.cancelBunnyUpload);
    context.commit('setSuccess', null);
    return data.cancelBunnyUpload;
  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function fetchBunnyDownloadUrl(context, vdoSetTopicId) {
  context.commit('setProcessing', true);
  try {
    const {data, errors} = await apolloClient.query({
      query: BUNNY_DOWNLOAD_URL,
      variables: {vdoSetTopicId},
      // Same policy as every other action in this module: a URL cached from
      // before a re-upload would point at the previous video's guid.
      fetchPolicy: 'network-only',
    });

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    }
    context.commit('setSuccess', null);
    return data.bunnyDownloadUrl;
  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}
